import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AXIOS } from '../api';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import parser from 'react-html-parser';
import moment from 'moment';

import { setFiltrage, setLoading, setFetch } from '../redux/actions';
import { Box, Text, Icons, Icon, PictureItem, Button } from './common/Themes';
import { ACTIVITES_ID } from '../database';

const GestionFormules = () => {
    const dispatch = useDispatch();
    const { activites, offres, formules, rooms } = useSelector((state) => state.fetch);
    const {
        filtrage: { aidActive, oidActive },
        fetch,
    } = useSelector((state) => state.config);

    const [offresFill, setOffresFill] = useState([]);
    const [formulesFill, setFormulesFill] = useState([]);

    const [aidFil, setAidFil] = useState();
    const [oidFil, setOidFil] = useState();

    // const [aidActive, setAidActive] = useState(false)
    // const [oidActive, setOidActive] = useState(false)

    // GET DATA FROM API
    useEffect(() => {
        setOffresFill(offres);
        setFormulesFill(formules);
        setAidFil(activites[0]?.aid);
    }, [offres, formules, activites]);

    useEffect(() => {
        if (aidActive) {
            if (oidActive) setFormulesFill(formules.filter(({ aid, oid }) => aid == aidFil && oid == oidFil));
            else setFormulesFill(formules.filter(({ aid }) => aid == aidFil));
        } else {
            if (oidActive) setFormulesFill(formules.filter(({ oid }) => oid == oidFil));
            else setFormulesFill(formules);
        }
    }, [aidFil, aidActive, oidFil, oidActive]);

    useEffect(() => {
        if (aidFil !== undefined) {
            setOffresFill(offres.filter(({ aid }) => aid === aidFil));
            setOidFil(offres.filter(({ aid }) => aid === aidFil)[0]?.oid);
        }
    }, [aidFil]);

    const deleteHandler = async (fid) => {
        try {
            dispatch(setLoading(true));
            await AXIOS.delete(`/api/v1/formules/${fid}`);
            dispatch(setFetch(!fetch));
            dispatch(setLoading(false));
        } catch (error) {
            console.log(error);
        }
    };

    const gestionItem = (fid, oid, aid, classement, name, article, ROOMS, image, color, date) => {
        let roomsLabel = [];
        const offre = offres.filter((offre) => offre.oid === oid)[0];
        const activite = activites.filter((activite) => activite.aid === aid)[0];

        rooms.map(({ id, name }) =>
            ROOMS?.split(',').map((ROOM) => {
                if (id.toString() === ROOM) roomsLabel = [...roomsLabel, name];
            })
        );

        return (
            <Box key={fid}>
                <input style={{ margin: '0 1rem' }} type="checkbox" defaultChecked={article?.length > 0}></input>
                <PictureItem image={`url(${process.env.REACT_APP_SITE_MARCHAND}${image})${aid === ACTIVITES_ID[`snaking`] ? '' : ", url('/img/default_image.png')"}`}>&nbsp;</PictureItem>
                <Text color={activite?.color1} style={{ width: '14rem' }}>
                    {classement}
                </Text>
                <Text color={activite?.color1}>{parser(name)}</Text>
                <Text color={activite?.color1}>{parser(offre?.name)}</Text>
                <Text color={activite?.color1}>{parser(activite?.name)}</Text>
                <Text color={activite?.color1} style={{ width: '15rem' }}>
                    {aid === ACTIVITES_ID[`evenements`] ? (!date ? `défaut` : moment(date).format('DD/MM/YYYY')) : ''}
                </Text>
                {/* SNACKING PART */}
                {/* <Text color={activite?.color1} style={{ flexGrow: 3, padding: '0 5px 0 20px', marginRight: '12.6px', fontSize: '12px', height: '57.4px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', overflow: 'auto', position: 'relative' }}>
                    <div style={{ position: 'absolute', top: '0' }}>
                        {roomsLabel.map((room, index) => (
                            <div key={index}>{`${index + 1} - ${room}`}</div>
                        ))}
                    </div>
                </Text> */}
                <div style={{ marginLeft: 'auto' }}>
                    <Link to={`/formule/${fid}`}>
                        <Icons color={activite?.color1}>
                            <use xlinkHref="/img/sprite.svg#icon-edit"></use>
                        </Icons>
                    </Link>
                    <Icons onClick={() => deleteHandler(fid)} color={activite?.color1}>
                        <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                    </Icons>
                </div>
            </Box>
        );
    };

    const handleChange = (e) => setFormulesFill(formules.filter(({ name }) => name?.toLocaleLowerCase().includes(e.target.value?.toLocaleLowerCase())));

    return (
        <>
            <div className="gestion">
                <div className="gestion__header">
                    <h4 className="gestion__title">Gestion formules</h4>
                    <h5 className="gestion__total">{formules.length} Total</h5>

                    <div style={{ marginLeft: 'auto', display: 'flex', position: 'relative' }}>
                        <input name="search" onChange={handleChange} className="gestion__input" placeholder="Rechercher" />
                        <Icons color="#B0BAC9" style={{ margin: '1rem', position: 'absolute', right: '1rem' }}>
                            <use xlinkHref="/img/sprite.svg#icon-search"></use>
                        </Icons>
                    </div>
                </div>
                <div className="gestion__container">
                    <h4 className="gestion__subTitle">Filtrage des formules</h4>
                    <div className="gestion__filtrage">
                        <div className="gestion__filtrageWrapper">
                            <Switch checked={aidActive} onColor="#45B755" offColor="#ED292D" onChange={() => dispatch(setFiltrage({ aidActive: !aidActive, oidActive }))} />
                            <div className="form__inputbox gestion__inputbox">
                                <label htmlFor="birthday" className="form__label">
                                    Activité
                                </label>
                                <select name="aid" onChange={(e) => setAidFil(e.target.value)} className="form__input" style={{ padding: '0 1rem' }}>
                                    {activites.map(({ aid, name }) => (
                                        <option className="form__dropdown" key={aid} value={aid}>
                                            {name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="gestion__filtrageWrapper">
                            <Switch checked={oidActive} onColor="#45B755" offColor="#ED292D" onChange={() => dispatch(setFiltrage({ aidActive, oidActive: !oidActive }))} />
                            <div className="form__inputbox gestion__inputbox">
                                <label htmlFor="birthday" className="form__label">
                                    Offre
                                </label>
                                <select name="oid" onChange={(e) => setOidFil(e.target.value)} className="form__input" style={{ padding: '0 1rem' }}>
                                    {offresFill.map(({ oid, name }) => (
                                        <option className="form__dropdown" key={oid} value={oid}>
                                            {name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <Button to="/formule" color={'#FF5C00'} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Icons color={'#fff'} style={{ margin: '0 1rem 0 0', width: '16px' }}>
                        <use xlinkHref="/img/sprite.svg#icon-plus"></use>
                    </Icons>
                    Nouveau
                </Button>
                <div className="gestion__content">
                    <div className="gestion__listheader">
                        <div className="gestion__headerItem" style={{ width: '14.4rem' }}></div>
                        <div className="gestion__headerItem" style={{ width: '14.4rem' }}>
                            Classement
                        </div>
                        <div className="gestion__headerItem">Name</div>
                        <div className="gestion__headerItem">Offre</div>
                        <div className="gestion__headerItem">Activité</div>
                        <div className="gestion__headerItem"></div>
                    </div>
                    <div className="gestion__list">{formulesFill.map(({ fid, oid, aid, classement, name, article, rooms, image, color, date }) => gestionItem(fid, oid, aid, classement, name, article, rooms, image, color, date))}</div>
                    <Link to="/formule" style={{ alignSelf: 'center' }}>
                        <Icon color={'#FF5C00'} style={{ marginBottom: '0' }}>
                            <use xlinkHref="/img/sprite.svg#icon-plus-alt"></use>
                        </Icon>
                    </Link>
                </div>
            </div>
        </>
    );
};

export default GestionFormules;
